/**
 * @generated SignedSource<<e2e445f54e14145be656265a50fae503>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type InternShopifyOrdersCardQuery$variables = {
  brandId: string;
  days: number;
};
export type InternShopifyOrdersCardQuery$data = {
  readonly brand: {
    readonly orderMetricsSummary: {
      readonly attributionRate: number;
      readonly dailyStats: ReadonlyArray<{
        readonly date: string;
        readonly kinnInvolvedOrders: number;
        readonly kinnOrders: number;
        readonly totalOrders: number;
      }>;
      readonly involvementRate: number;
      readonly kinnInvolvedOrders: number;
      readonly kinnOrders: number;
      readonly totalOrders: number;
    };
  };
};
export type InternShopifyOrdersCardQuery = {
  response: InternShopifyOrdersCardQuery$data;
  variables: InternShopifyOrdersCardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "days"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "brandId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalOrders",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kinnInvolvedOrders",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kinnOrders",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "days",
      "variableName": "days"
    }
  ],
  "concreteType": "BrandOrderMetricsSummary",
  "kind": "LinkedField",
  "name": "orderMetricsSummary",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandOrderDailyStats",
      "kind": "LinkedField",
      "name": "dailyStats",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "involvementRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attributionRate",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternShopifyOrdersCardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternShopifyOrdersCardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2fe201078da1bb09d793acf6e4b11135",
    "id": null,
    "metadata": {},
    "name": "InternShopifyOrdersCardQuery",
    "operationKind": "query",
    "text": "query InternShopifyOrdersCardQuery(\n  $brandId: ID!\n  $days: Int!\n) {\n  brand(id: $brandId) {\n    orderMetricsSummary(days: $days) {\n      dailyStats {\n        date\n        totalOrders\n        kinnInvolvedOrders\n        kinnOrders\n      }\n      totalOrders\n      kinnInvolvedOrders\n      kinnOrders\n      involvementRate\n      attributionRate\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "02388da43a22841d1c7779216d524f07";

export default node;
